import { useTranslation } from 'react-i18next';
import PaymentProvider from '../../../shared/PaymentProvider';
import Layout from '../../../shared/layouts/Layout';
import { MetaTags } from '../../../../hub/shared/MetaTags';
import PageLayout from '../../../shared/layouts/PageLayout';
import BookingClosedMessage, {
  BookingClosedMessageProps,
} from '../components/BookingClosedMessage';

interface BookingClosedProps extends BookingClosedMessageProps {}

export default function BookingClosed(props: BookingClosedProps) {
  const { errorMessage, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <PaymentProvider>
      <Layout disableUpperFooter>
        <MetaTags title={t('site.pricing.booking-closed')} />
        <PageLayout variant="full">
          <BookingClosedMessage errorMessage={errorMessage} {...restProps} />
        </PageLayout>
      </Layout>
    </PaymentProvider>
  );
}
